import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import ListingComponent from '../../components/ListingComponent';
import FiltersPartial from "./FiltersPartial.js";
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Listing = (props) => {
  const [filtersModel, setFiltersModel] = useState(props.defaultParams?.filters || {});
  const defaultHeaderConfig = { disableSort: false };
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Ticket',
      value: (row) => {
        return <div>
          <div>{row.category?.name } ({row.ticket?.name})</div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Raised for',
      value: (row) => {
        return <div>
          {(row.raised_for && Object.keys(row.raised_for).length > 0 &&
            <>
              <div>{row.raised_for.name}</div>
            </>)
          || '-'}
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true

    },
    {
      ...defaultHeaderConfig,
      label: 'Assigned To',
      value: (row) => {
        return <div>
          {row.ticket.assign_to}
        </div>
      },
      disableSort: true

    },
    {
      ...defaultHeaderConfig,
      label: 'Service Center',
      value: (row) => {
        return <div>
          {(Object.keys(row.service_center).length > 0 &&
            <>
              <div>{row.service_center.name}</div>
              <div>({row.service_center.sc_nomenclature})</div>
            </>) || '-'
          }
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Handler',
      value: (row) => {
        return <div>
          {(Object.keys(row.assigned_person || {}).length > 0 &&
            <>
              <div>{row.assigned_person.name}</div>
              <div>({row.assigned_person.id})</div>
            </>) || '-'
          }
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at'
    },
    {
      ...defaultHeaderConfig,
      label: 'Updated At',
      attr: 'updated_at'
    },
    {
      ...defaultHeaderConfig,
      label: 'Action',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_work_order_details.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      },
      disableSort: true
    }
  ]

  const onViewClick = (id) => {
    navigate(`/work_orders/${id}`)
  }

  return <ListingComponent
    key={"PAGES.WorkOrdersListingPage.name"}
    listingMutation={getApi('workOrders')}
    contentHeading="Workorders List - Results"
    headers={headers}
    recordsKey="work_orders"
    params={props.defaultParams}
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
    searchBy={["Service Center ID"]}
  />
};

export default Listing;
